import { render } from "./ContactanosApp.vue?vue&type=template&id=55c0f9dd&scoped=true"
import script from "./ContactanosApp.vue?vue&type=script&lang=js"
export * from "./ContactanosApp.vue?vue&type=script&lang=js"

import "./ContactanosApp.vue?vue&type=style&index=0&id=55c0f9dd&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend_ahdeco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c0f9dd"]])

export default __exports__